import * as React from 'react'
import {Util} from 'yougile-util'
import {Option} from '../select/select'
import {StateUpdaters, withStateHandlers} from 'recompose'
import {Lang} from 'yougile-lang'
import {DropdownList} from '@components/common/dropdown-list/dropdown-list'
import {LinkButtonSmall} from '@components/common/button/button'
import AddIcon from '@components/statistics/stats-reports/add.svg'

interface Props {
  options: Option[]
  onSelect?: (value: string) => void
  placeholder?: string
  buttonLabel?: string
  className?: string
  dropdownOffset?: number
  withIcon?: boolean
  children?: React.ReactNode
}

interface State {
  adding: boolean
}

interface Handlers {
  startAdd?: () => State
  cancelAdd?: () => State
}

const ButtonSelectBase = (props: Props & State & Handlers) => {
  const {
    options,
    className = '',
    onSelect = Util.noop,
    placeholder = '—',
    buttonLabel = Lang.msg.add,
    adding,
    cancelAdd,
    startAdd,
    children
  } = props
  const bem = Util.bemFrom('button-select')

  return (
    <div className={bem() + ' ' + className}>
      {!adding ? (
        <LinkButtonSmall className="mr-4" onClick={startAdd}>
          <AddIcon className="mr-2" />
          {buttonLabel}
        </LinkButtonSmall>
      ) : (
        <>
          <div style={{marginLeft: props.dropdownOffset}}>
            <DropdownList
              className="w-184"
              initialOpen={true}
              options={options}
              onChange={onSelect}
              placeholder={placeholder}
              value={undefined}
            />
          </div>
          <div className={bem('cancel')} onClick={cancelAdd}>
            {Lang.msg.cancel}
          </div>
        </>
      )}
      {children}
    </div>
  )
}

const handlers: StateUpdaters<Props, State, Handlers> = {
  startAdd: () => () => ({adding: true}),
  cancelAdd: () => () => ({adding: false})
}

export const ButtonSelect = (props: Props) => {
  const WithState = withStateHandlers(
    {adding: false},
    handlers
  )(ButtonSelectBase)
  return <WithState {...props} />
}
